import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const slides = [
  {
    id: 1,
    image: "https://static.lumi.new/28/281994db49a99d7dfbe9208af49a5f26.png", // Tourism
    title: "Marketing Aéreo Turístico e Eventos",
    description: "Revelando a beleza da Bahia sob uma nova perspectiva."
  },
  {
    id: 2,
    image: "https://static.lumi.new/76/76744950f49b2367852fd1cd97275528.png", // Construction
    title: "Acompanhamento de Obras",
    description: "Monitoramento preciso para construção civil e engenharia."
  },
  {
    id: 3,
    image: "https://static.lumi.new/62/62b36870e47d4ce4d527bb6e1b387c79.png", // Real Estate
    title: "Marketing Imobiliário de Alto Padrão",
    description: "Valorize empreendimentos com imagens aéreas exclusivas."
  },
  {
    id: 4,
    image: "https://static.lumi.new/73/73e696b2e469e2c25312075f0a27dd66.png", // Mapping
    title: "Mapeamento Aéreo e Georreferenciamento",
    description: "Soluções técnicas de ortofotografia para terrenos e áreas rurais."
  }
];

export default function Hero() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden bg-black">
      <AnimatePresence mode="wait">
        <motion.div
          key={current}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          className="absolute inset-0"
        >
          <div 
            className="absolute inset-0 bg-cover bg-center bg-no-repeat transform scale-105"
            style={{ backgroundImage: `url(${slides[current].image})` }}
          />
          <div className="absolute inset-0 bg-black/50" /> {/* Overlay */}
        </motion.div>
      </AnimatePresence>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8">
        <motion.div
          key={`text-${current}`}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 tracking-tight">
            {slides[current].title}
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            {slides[current].description}
          </p>
        </motion.div>
      </div>

      {/* Indicators */}
      <div className="absolute bottom-10 left-0 right-0 flex justify-center gap-3 z-20">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 rounded-full transition-all duration-300 ${
              index === current ? 'bg-blue-600 w-8' : 'bg-white/50 hover:bg-white'
            }`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
}
